import { connect } from 'react-redux';
import {
  getCustomerUsers,
  getActivationKeyDetails,
  getCustomerUsersSuccess,
  getOnlineCustomers,
  getOnlineCustomersSuccess,
} from 'src/Actions/Customers/customerAction';
import {
  getUserDetails,
  displayToast,
  updateUser,
} from 'src/Actions/Admin/adminActions';
import { manageSidemenu } from 'src/Actions/Generic/genericActions';
import GETrainers from './GETrainers';
export const mapStateToProps = ({
  customer,
  subscription,
  admin,
  generic,
  collab,
}) => ({
  customer,
  subscription,
  admin,
  collab,
  generic,
});

export const mapDispatchToProps = (dispatch) => ({
  getCustomerUsers: (payload, loadMore) =>
    dispatch(getCustomerUsers(payload, loadMore)),
  getUserDetails: (emailId, activationKey) =>
    dispatch(getUserDetails(emailId, activationKey)),
  displayToast: (val) => dispatch(displayToast(val)),
  manageSidemenu: (val) => dispatch(manageSidemenu(val)),
  getActivationKeyDetails: (emailId) =>
    dispatch(getActivationKeyDetails(emailId)),
  getCustomerUsersSuccess: (ob) => dispatch(getCustomerUsersSuccess(ob)),
  updateUser: (activationKey, isValid, email, searchKey) =>
    dispatch(updateUser(activationKey, isValid, email, searchKey)),
  getOnlineCustomers: (payload) => dispatch(getOnlineCustomers(payload)),
  getOnlineCustomersSuccess: (ob) => dispatch(getOnlineCustomersSuccess(ob)),
  getCustomerList: (payload) => dispatch(getCustomerList(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GETrainers);
